export const prepareAdvancementConfigForSave = (config) => {
  return {
    advancementEnabled: Boolean(config.advancementEnabled ?? true),
    maxAdvancementAmount: config.maxAdvancementAmount != null
      ? parseFloat(config.maxAdvancementAmount)
      : null,
    maxAdvancementPercentOfSalary: config.maxAdvancementPercentOfSalary != null
      ? parseFloat(config.maxAdvancementPercentOfSalary)
      : null,
    minMonthsOfService: config.minMonthsOfService != null
      ? parseInt(config.minMonthsOfService)
      : null,
    maxActiveAdvancements: config.maxActiveAdvancements != null
      ? parseInt(config.maxActiveAdvancements)
      : null,
    maxAdvancementsPerMonth: config.maxAdvancementsPerMonth != null
      ? parseInt(config.maxAdvancementsPerMonth)
      : null,
    maxMonthlyAdvancementTotal: config.maxMonthlyAdvancementTotal != null
      ? parseFloat(config.maxMonthlyAdvancementTotal)
      : null,
    defaultInstallments: config.defaultInstallments != null
      ? parseInt(config.defaultInstallments)
      : null,
    minInstallments: config.minInstallments != null
      ? parseInt(config.minInstallments)
      : null,
    maxInstallments: config.maxInstallments != null
      ? parseInt(config.maxInstallments)
      : null,
    requireManagerApproval: Boolean(config.requireManagerApproval ?? true),
    requireHRApproval: Boolean(config.requireHRApproval ?? true),
    autoApproveUnderAmount: config.autoApproveUnderAmount != null
      ? parseFloat(config.autoApproveUnderAmount)
      : null,
    advancementProcessingDays: config.advancementProcessingDays != null
      ? parseInt(config.advancementProcessingDays)
      : null,
    allowEmergencyAdvancements: Boolean(
      config.allowEmergencyAdvancements ?? true
    ),
    emergencyMaxAmount: config.emergencyMaxAmount != null
      ? parseFloat(config.emergencyMaxAmount)
      : null,
    deductionStartDelay: config.deductionStartDelay != null
      ? parseInt(config.deductionStartDelay)
      : null,
    blockAdvancementIfPending: Boolean(
      config.blockAdvancementIfPending ?? true
    ),
    blockAdvancementIfOverdue: Boolean(
      config.blockAdvancementIfOverdue ?? true
    ),
    advancementNotifications: Boolean(
      config.advancementNotifications ?? true
    ),
  };
};